import { menuAnatomy as parts } from "@chakra-ui/anatomy"
import { createMultiStyleConfigHelpers, cssVar } from "@chakra-ui/styled-system"

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(parts.keys)

const $bg = cssVar("menu-bg")

const variantMainActions = definePartsStyle({
  list: {
    [$bg.variable]: "white",
  },
  item: {
    _focus: {
      [$bg.variable]: "colors.neutrals.50",
    },
    _active: {
      [$bg.variable]: "white",
    },
  },
})

/**
 * @see https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/menu.ts
 */
export const Menu = defineMultiStyleConfig({
  baseStyle: {
    list: {
      boxShadow: "0px 0px 30px rgba(0, 0, 0, 0.07)",
      borderRadius: "xl",
      overflow: "hidden",
      pt: 0,
      pb: 0,
      minW: "10rem",
      zIndex: 3,
    },
    item: {
      fontSize: 14,
      pl: 4,
      pr: 8,
      pt: { base: 2, lg: 2.5 },
      pb: { base: 2, lg: 2.5 },
      color: "neutrals.900",
      borderBottom: "1px solid",
      borderColor: "neutrals.200",
    },
    groupTitle: {
      fontSize: 12,
      pb: 1,
    },
  },
  variants: {
    mainActions: variantMainActions,
  },
})
